export default {
    install(app) {
        app.directive('input-limit', {
            mounted(el, params) {
                if (el && (el instanceof HTMLInputElement || el instanceof HTMLTextAreaElement)) {
                    const reg = params?.value?.reg;
                    if (reg) {
                        el.addEventListener('keyup', (evt) => {
                            evt.preventDefault();
                            el.value = evt.target.value.replace(new RegExp(reg, 'ig'), '');
                        });
                    }
                }
            }
        });
    }
};
